import React from "react";

const WHATSAPP_NUMBER = "256708435802";
const WHATSAPP_MESSAGE = "Hi! I'm interested in acquiring SourceCodey.";
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  WHATSAPP_MESSAGE
)}`;

function openWhatsApp() {
  window.open(WHATSAPP_URL, "_blank", "noopener,noreferrer");
}

export default function AcquireBanner() {
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={openWhatsApp}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") openWhatsApp();
      }}
      style={styles.card}
    >
      <span style={styles.text}>Acquire SourceCodey for $999 Only!</span>

      <button
        type="button"
        style={styles.button}
        onClick={(e) => {
          e.stopPropagation();
          openWhatsApp();
        }}
      >
        Contact Us
      </button>
    </div>
  );
}

const styles = {
  card: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    padding: "16px 20px",
    borderRadius: "20px",
    background: "linear-gradient(115deg, #3654D1 0%, #7B2FF7 55%, #FF7A29 100%)",
    cursor: "pointer",
    border: "none",
    boxShadow: "0 6px 20px rgba(60, 30, 130, 0.25)",
    userSelect: "none",
  },
  text: {
    color: "#FFFFFF",
    fontSize: "15px",
    fontWeight: 600,
    lineHeight: 1.3,
    flex: 1,
  },
  button: {
    flexShrink: 0,
    padding: "8px 18px",
    borderRadius: "999px",
    border: "none",
    background: "#FFFFFF",
    color: "#4B2FB7",
    fontSize: "13px",
    fontWeight: 600,
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
};